export const ContactPage = ['$scope', '$http', function($scope, $http) {
    $scope.form = {}
    $scope.message = ""
    $scope.contactSubmit = function(e) {
        e.preventDefault()
        $http({
            method: 'POST',
            url: '/wp-json/richman/v1/contact-form',
            data: {
                form: $scope.form,
            }
        }).then(function successCallback(response) {
            console.log('response ' , response);
            // send data to realpage API
            $scope.sendToRealPage($scope.form);
            $scope.contactState = 'success'

            // $scope.showErrors = false;
        }, function errorCallback(response) {
            $scope.contactState = 'error'
            // console.log('error response ' , response);
        });
    }


    $scope.sendToRealPage = function(data) {
        $http({
            method: 'POST',
            url: '/wp-json/richman/v1/realpageapi',
            data: {
                url: 'https://onesite.realpage.com/WebServices/CrossFire/prospectmanagement/service.asmx',
                property_id: data.property_id,
                SOAPAction: "http://realpage.com/webservices/InsertProspect",
                soapBody:   `<InsertProspect xmlns="http://realpage.com/webservices">
                              <guestCard>
                                <Prospects>
                                  <Prospect>
                                    <FirstName>${data.first_name}</FirstName>
                                    <LastName>${data.last_name}</LastName>
                                    <Email>${data.email}</Email>
                                    <Numbers>
                                        <Number>${data.phone}</Number>
                                    </Numbers>
                                  </Prospect>
                                </Prospects>
                              </guestCard>
                            </InsertProspect>`,
            }
        }).then(function successCallback(response) {
            // console.log('response ' , response);
        }, function errorCallback(response) {
            // console.log('error response ' , response);
        });
    }


}];